<template>
  <div class="container is-fluid is-marginless">
    <div class="section">
      <div class="level">
        <div class="level-left">
          <a @click="$router.push({ name: 'liste-panneau' })">
            <b-icon icon="chevron-left" type="is-default"></b-icon>
            <span class="has-text-grid-1 has-text-weight-bold is-size-4 ml-10">
              {{$t('headerPanier.mySelection')}}
            </span>
          </a>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button type="is-transparent" class="has-text-default"
              @click="$router.push({ name: 'liste-panneau' })">
              {{$t('headerPanier.continueSelection')}}
            </b-button>
          </div>
          <div class="level-item">
            <b-button
              type="is-primary"
              class="has-text-weight-bold ml-20"
              @click="creerRecommandation">
              {{ isEditRecom ? $t('headerPanier.buttonModif') : $t('headerPanier.buttonCreate') }}
            </b-button>
          </div>
        </div>
      </div>
      <MsgError
        v-if="msgErrors.length"
        type="is-danger"
        :msgs="msgErrors"
        :autoClose="false"
        @close="msgErrors = []"/>
      <div v-if="recommandation" class="level mt-40">
        <div class="level-left">
          <div class="level-item" v-if="isEditRecom">
            <recom-label
              :recommandation="recommandation"
              isPanier showLabel>
            </recom-label>
          </div>
          <div class="level-item">
            <b-field custom-class="mb-4px campagne" class="mb-20">
              <template slot="label">
                <p class="has-text-default is-size-7">
                  {{$t('headerPanier.labelThemeCampagne')}}
                </p>
              </template>
              <b-input type="text" v-model="recommandation.theme"></b-input>
            </b-field>
          </div>
          <div class="level-item">
            <societe-selector isPanier/>
          </div>
          <div class="level-item">
            <b-field custom-class="mg-4px"  class="mb-20">
              <template slot="label">
                <qd-label :label="$t('headerPanier.assistant')" />
              </template>
              <b-select
                :value="assistant"
                @input="setAssistantId"
                :placeholder="$t('headerPanier.assistant')"
                class="inputSociete is-min-width-300px"
                expanded>
                <option> </option>
                <option
                  v-for="user in assistantsCommerciaux"
                  :key="user.id"
                  :value="user.id">
                  {{ user.nom }} {{ user.prenom }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-field custom-class="mg-4px"  class="mb-20">
              <template slot="label">
                <qd-label :label="$t('headerPanier.afficherPanneauxSousContrat')" />
              </template>
              <b-checkbox v-model="recommandation.afficherPanneauxSousContrat" />
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <RecapBudget/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MsgError from '@/components/general/messageErreur';
import RecapBudget from '@/components/panier/recapBudget.vue';
import gestionErreur from '@/services/general/gestionErreur';
import SocieteSelector from '@/components/general/societeSelector';
import RecomLabel from '@/components/recommandation/recomLabel';
import validation from '@/services/recommandation/validation';
import translator from '@/services/recommandation/translator';
import validationGeneral from '@/services/validation/validation';
import { isValidPanneau } from '@/services/gestionPanneau/validationPanneau';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import { CALCULER_THEME, SET_ASSISTANT_ID } from '@/store/modules/recommandations-mutation-type';
import QdLabel from '@/components/general/qdLabel.vue';

const Recommandations = createNamespacedHelpers('recommandations');
const Parametres = createNamespacedHelpers('parametrage');


export default {
  components: {
    MsgError,
    RecapBudget,
    SocieteSelector,
    QdLabel,
    RecomLabel,
  },
  data() {
    return {
      msgErrors: [],
    };
  },
  created() {
    this.calculerTheme();
  },
  computed: {
    ...Recommandations.mapGetters({
      recommandation: 'recommandation',
      panneaux: 'panneaux',
      assistant: 'assistant',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
    isEditRecom() {
      return !!this.recommandation && !!this.recommandation.id;
    },
    assistantsCommerciaux() {
      return (this.users || []).filter(u => u.profil === 'AssistantCommercial');
    },
  },
  methods: {
    ...Recommandations.mapActions({
      sauvegarderRecommandationDevis: 'sauvegarderRecommandationDevis',
    }),
    ...Recommandations.mapMutations({
      calculerTheme: CALCULER_THEME,
      setAssistantId: SET_ASSISTANT_ID,
    }),
    async creerRecommandation() {
      this.msgErrors = [];
      const panneauxWithError = this.panneaux.filter(p => !p.estPanneauSousContrat && !isValidPanneau(p));
      if (panneauxWithError.length) {
        this.msgErrors.push(this.$t('devis.errors.productsWithError'))
        return;
      }
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const devis = await this.sauvegarderRecommandationDevis();
        this.$router.push({
          name: 'detail-recommandation',
          params: { id: devis.id },
        });
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
          const msg = [];
          validationGeneral(this.$i18n, error.response, msg, translator);
          validation(error.response, msg);
          if (msg.length) {
            this.msgErrors = msg.map(el => this.$t(el.message, el.parametres));
          }
        }
        gestionErreur(this.$t('errors.erreurCreationRecommandation'), error);
      } finally {
        loadingComponent.close();
      }
    }
  },
};
</script>
